module.exports = __webpack_public_path__ + "media/images/icons/SVG/056-d47f05a725a459ebd9d3c1ff539369ca.svg";